import { CustomMeasureProvider, defToMeasure } from 'services/model/customMeasures';
import { InterpretationValue } from 'models/measureInterpretation';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { useIntl } from 'react-intl';

export const usePriceChangeMeasures = () => {
  const intl = useIntl();
  return {
    oldPrice: defToMeasure(
      {
        code: 'oldPrice',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.CURRENCY,
        translationId: 'trading.price_change.table.old',
      },
      intl
    ),
    newPrice: defToMeasure(
      {
        code: 'newPrice',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.CURRENCY,
        translationId: 'trading.price_change.table.new',
      },
      intl
    ),
    priceChangeDelta: defToMeasure(
      {
        code: 'priceChangeDelta',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.PERCENT,
        translationId: 'trading.price_change.table.price_change_percent',
      },
      intl
    ),
    dailyQty: defToMeasure(
      {
        code: 'dailyQty',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.QUANTITY,
        translationId: 'trading.price_change.table.new_price_label',
      },
      intl
    ),
    dailyQtyDelta: defToMeasure(
      {
        code: 'dailyQtyDelta',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.PERCENT,
        translationId: 'trading.price_change.table.delta',
      },
      intl
    ),
    dailyGmv: defToMeasure(
      {
        code: 'dailyGmv',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.CURRENCY,
        translationId: 'trading.price_change.table.new_price_label',
      },
      intl
    ),
    dailyGmvDelta: defToMeasure(
      {
        code: 'dailyGmvDelta',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.PERCENT,
        translationId: 'trading.price_change.table.daily_gmv_delta_percent',
      },
      intl
    ),
    totalCM1: defToMeasure(
      {
        code: 'totalCM1',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.CURRENCY,
        translationId: 'trading.price_change.table.new_price_label',
      },
      intl
    ),
    cm1Delta: defToMeasure(
      {
        code: 'cm1Delta',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.PERCENT,
        translationId: 'trading.price_change.table.cm1_delta_percent',
      },
      intl
    ),
  } as CustomMeasureProvider;
};
